<template>
    <div id="divTerms" v-if="termsDataLoaded">
        <div class="header-nav">
            <ul class="menu">
                <li><span v-html="termsData.Title"></span></li>
            </ul>
        </div>

        <div id="divContent" class="main-content-row">
            <div id="divTerms">
                <p v-html="termsData.Agreement"></p>
            </div>

            <div id="divTermsAccept">
                <input id="chkAgree" type="checkbox" name="chkAgree" class="checkbox-inline" v-model="termsData.AgreementAccepted">
                <label for="chkAgree">{{ $t("message.terms") }}</label>
                <br />
                <input id="btnSubmit" type="submit" name="btnSubmit" value="Submit" class="btn btn-sm btn-primary" 
                    :disabled="isSubmitBtnDisabled" @click.prevent="acceptAgreement()" aria-label="Accept Agreement" />
            </div>
        </div>        
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'Terms',
    data() {
        return {
            termsData: {
                TermAndConditionId: -1,
                CustomerId: -1,
                Title: 'Terms and Conditions',
                Agreement: '',
                AgreementAccepted: false,
                RedirectLink: ''
            },
            termsDataLoaded: false
        }
    },
    beforeCreate() {
        axios({
            method: "GET",
            url: this.$httpAxiosBaseUrl() + "Terms/GetTermsAndConditions?date=" + new Date().getTime()
        }).then(result => {
            var response = result.data;
            if (response !== '') {
                this.termsData = response;
                var redirectUrl = this.termsData.RedirectLink;

                // If terms and conditions are not setup and we get a valid redirect url back, forward user to that page OR else to the homepage
                if (this.termsData.TermAndConditionId === 0) {
                    this.$router.push({ path: redirectUrl !== '' ? redirectUrl : '/home' });
                    return;
                } else {
                    // Terms and conditions are setup, display terms content
                    this.termsDataLoaded = true;
                }
            }
        }, error => {
            console.log(error);
        });
    },
    methods: {
        acceptAgreement() {
            axios({
                method: "POST",
                url: this.$httpAxiosBaseUrl() + "Terms/AcceptTermsAndCondition",
                data: {
                    customerTerms: this.termsData
                }
            }).then(result => {
                var response = result.data;
                if (response !== '' && response.RedirectLink !== '') {
                    this.$router.push({ path: response.RedirectLink });                   
                } else {
                    this.termsData.AgreementAccepted = false;
                }
            }, error => {
                console.log(error);
            });
        }
    },
    computed: {
        isSubmitBtnDisabled() {
            return !this.termsData.AgreementAccepted;
        }
    }
}
</script>